export default {
    SET_PROJECT (state, data) {
      state.project = data
    },
    SET_BOT (state, data) {
      state.bot = data
    },
    SET_ERROR (state, data) {
      state.error = data
    },
    SET_LOADING (state, data) {
      state.loading = data
    },
    BOT_RAN_NOW(state,data) {    
      state.loading = false;
    },
    SORT_SCENARIO(state, data) {
      state.bot.data.scenario = data;
    },
    SET_EDITED_ID(state, data) {
      state.bot.idToEdit = data;
    },
    BOT_COPIED(state, data) {
      
    },
    BOT_UPDATED(state, data) {
      
      /**var filteredEntity = state.bots.data.filter(function(entity){
        if (entity.id == data.bot_id) {
          return entity;
        }
      })[0];
       
      var index = state.bots.data.indexOf(filteredEntity);
      state.bots.data[index] = data;*/
    }
  }
  